import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { BaseModalPageComponent } from '../../../base-modal.component';
import { ModalComponent } from '../../../modal/modal.component';
import { AppVersion } from '../../models';

@Component({
    selector: 'new-version-modal',
    templateUrl: 'new-version-modal.component.html',
    standalone: false
})
export class NewVersionModalComponent extends BaseModalPageComponent {
  appVersion: AppVersion;
  index = 0;

  constructor(public selfModal: ModalComponent, location: Location) {
    super(location);
  }

  public init(data: any) {
    Object.assign(this, data);
  }

  next() {
    this.index >= this.appVersion.blocks.length - 1 ? (this.index = 0) : this.index++;
  }

  previous() {
    this.index <= 0 ? (this.index = this.appVersion.blocks.length - 1) : this.index--;
  }
}
